module.exports = __webpack_public_path__ + "static/media/1.ab6778d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16114/1.jpg
// module id = 539
// module chunks = 0